import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { CFRD_ACTIVITIES } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/cfrd/activities/")({
  component: () => <DeptContentList cfg={CFRD_ACTIVITIES} />,
});
